import React from 'react';

const TONES = {
  gray: 'bg-[#f1f1ef] text-[#787774]',
  brown: 'bg-[#f4eeee] text-[#976d57]',
  orange: 'bg-[#f8ecdf] text-[#c47d1a]',
  yellow: 'bg-[#fbf3db] text-[#9a6700]',
  green: 'bg-[#edf3ec] text-[#448361]',
  blue: 'bg-[#e7f0f5] text-[#337ea9]',
  purple: 'bg-[#f0e8f5] text-[#9065b0]',
  pink: 'bg-[#f8e8f0] text-[#c14c8a]',
  red: 'bg-[#fdebec] text-[#e03e3e]',
};

export function Chip({ tone = 'gray', children }) {
  return (
    <span
      className={`inline-flex items-center max-w-full h-[18px] px-1.5 rounded-[3px] text-[12px] leading-none truncate ${
        TONES[tone] || TONES.gray
      }`}
    >
      {children}
    </span>
  );
}

export function classificationTone(value) {
  const v = String(value || '');
  if (v.startsWith('Direct Personal')) return 'green';
  if (v === 'Role-Personal Hybrid') return 'blue';
  if (v === 'Team Functional' || v === 'High-Signal Generic') return 'blue';
  if (v === 'Standard Generic') return 'gray';
  if (v === 'Sales Alias') return 'orange';
  if (v === 'Ops / Customer-Facing') return 'brown';
  if (v === 'Back Office / Non-Revenue') return 'gray';
  if (v === 'Corporate / PR / Restricted') return 'purple';
  return 'gray';
}

export function verificationTone(value) {
  const v = String(value || '').toLowerCase();
  if (v === 'valid') return 'green';
  if (v === 'risky') return 'orange';
  if (v === 'invalid') return 'red';
  return 'gray';
}

export default Chip;
